import React from 'react';
import styled from 'styled-components';
import AresSpecialBodyContainer from './AresSpecialBodyContainer';
import UnderstandJESourceSCOT from '../../../JESource/UnderstandJESourceSCOT/UnderstandJESourceSCOT';

function UnderstandJESourceComponentBody(props) {
	const {
		showGuidance,
		guidanceFilter,
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView
	} = props;

	return (
		<StyledUnderstandJESourceComponentBody className="StyledJournalEntrySourceComponentBody">
			<AresSpecialBodyContainer
				showGuidance={showGuidance}
				guidanceFilter={guidanceFilter}
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView}
			>
				<UnderstandJESourceSCOT />
			</AresSpecialBodyContainer>
		</StyledUnderstandJESourceComponentBody>
	);
}

export default UnderstandJESourceComponentBody;

const StyledUnderstandJESourceComponentBody = styled.section``;
